import React from 'react'
import { List as OrganizationList } from '../../organization/components'
import { List as ProgramList } from '../../program/components'
import { List as EventList } from '../../event/components'
import { List as BlogList } from '../../blog/components'

const List = ({ selected = 'Program', data = [] }) => {
  return (
    <div>
      {
        selected === 'Program' &&
        <ProgramList data={data} uniform />
      }
      {
        selected === 'Organization' &&
        <OrganizationList data={data} />
      }
      {
        selected === 'Event' &&
        <EventList data={data} uniform />
      }
      {
        selected === 'Resources' &&
        <div className="px-2 lg:px-4">
          <p className="text-lg lg:text-2xl my-8 lg:my-0">Oops, the resource items was not found!</p>
        </div>
      }
      {
        selected === 'Blog' &&
        <BlogList data={data} uniform />
      }
    </div>
  )
}

export { List }